import React from "react";
import "./Loader.css";

const Loader = () => {
  // create a unique key each render (forces reload)
  const gifSrc = `https://varankal.s3.us-east-1.amazonaws.com/varankal/loader-unscreen.gif?${new Date().getTime()}`;

  return (
    <div className="loader-wrapper">
      <img
        src={gifSrc}
        alt="Loading..."
        className="reveal-gif"
      />
    </div>
  );
};

export default Loader;
